import { useEffect, useState } from "react";
import { AppListing } from "../../components/appListing";
import { useGetMedicationQuery } from "../../redux/service/careplan_service";
import moment from "moment";
import { MedicationDetailPharmacyDialog } from "./PharmacyDetail";
import MainPageDialog from './../../components/mainPageDialog';

export const Medications = ({ header = true, dataMeds = [], loading = false, legacyMode = false }) => {
   const [medicationsList, setMedicationsList] = useState([]);
   const [showDetailsInfoPopup ,setShowDetailsInfoPopup] = useState({state:false, dataObj:null})
   moment.updateLocale("fr", {
      invalidDate: "-",
   });

   const cols = [
      {
         title: "Medication",
         key: "drug",
         getData: (item) =>
            item?.drug ? (
               <div>
                  {item?.drug}
                  {
                     <>
                        <p className="black-c-600 ">
                           <strong>Substitution:</strong>{' '}
                           <span className="font-light">{item.substitute == true ? "Allowed" : "Not Allowed"}</span>
                        </p>
                     </>
                  }
                  {item?.days_supply && item?.days_supply != '' && (
                     <>
                     <p className="black-c-600 ">
                           <strong>Supply:</strong>{' '}
                           <span className="font-light">{item.days_supply} days</span>
                        </p>
                     </>
                  )}
                  {item?.frequency && item?.frequency != '' && (
                     <>
                     <p className="black-c-600 ">
                           <strong>Frequency:</strong>{' '}
                           <span className="font-light">{item.frequency} days</span>
                        </p>
                     </>
                  )}
                  
                  {/* {item?.ds_route && (
                     <>
                        <strong>Route:</strong> {item?.ds_route}
                     </>
                  )} */}
                  {item?.note && (
                     <>
                     <p className="black-c-600 ">
                     <strong>Sig: </strong> 
                        <span className="font-light">
                           {item?.note}. {item?.additional_sig}
                        </span> 
                        </p>
                       
                     </>
                  )}
                  {item?.pharmacy_notes && (
                     <>
                      <p className="black-c-600 ">
                           <strong>Pharmacy Notes:</strong>{' '}
                           <span className="font-light">{item.pharmacy_notes}</span>
                        </p>
                     </>
                  )}
                   {item?.Pharmacy?.name && (
                                  <>
                                    <p className="black-c-600 ">
                                      <strong>Pharmacy:</strong>{' '} 
                                      <span className="font-light">
                                          {item.Pharmacy?.name}
                                       </span>
                                      &nbsp;{" "}
                                      <span
                                        className="cursor-pointer text-sky-700 "
                                        onClick={() =>
                                          setShowDetailsInfoPopup({ state:true, dataObj: item?.Pharmacy })
                                        }
                                      >
                                        <u>[Details]</u>
                                      </span>
                                      {(item?.Pharmacy.script_version == '10.6' && (item?.note?.length + item?.additional_sig?.length) > 140) || (item.Pharmacy.script_version == '2017071' && (item.note.length + item.additional_sig.length)) > 1000 ? (
                                        <>
                                          <a
                                            href="javascript:{};"
                                            onClick={"showDirectionsCharacterLimitPopup(item)"}
                                            title="Click here to see Directions Limit"
                                          >
                                            <i className="exclaimation_icon"></i>
                                          </a>
                                        </>
                                      ) : ''}

                                    </p>
                                  </>
                                )}
                                {item?.Provider?.name && (
                                 <p className="black-c-600 ">
                                 <strong>Prescriber Name:</strong>{' '}
                                 <span className="font-light">{item?.Provider?.name}</span>
                              </p>
                                )}

               </div>
            ) : (
               "-"
            ),
      },
      {
         title: "Dispense",
         key: "dispense",
         getData: (item) => (item?.dispense ? item?.dispense + " " + item?.dispense_units : "-"),
      },
      { title: "Date", getData: (item) => moment(item?.date_written).format("MM/DD/YYYY") },
      { title: "Refills", getData: (item) => (item?.refills && item?.refills != "0" ? item?.refills : "-") },
   ];

   const useMedicationApi = header || legacyMode;
   const { data, refetch, isFetching, isLoading } = useGetMedicationQuery(
      { meds_for: "ccm" },
      { skip: !useMedicationApi }
   );

   useEffect(() => {
      if (data?.data?.approved_medication) {
         setMedicationsList(data.data.approved_medication);
      }
   }, [data]);

   const listData = useMedicationApi ? medicationsList : dataMeds || [];
   const isListingLoading = useMedicationApi ? isLoading || isFetching : loading;

   return (
      <>
         {header && (
            <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
               <div className="">
                  <h3 className="text-base font-semibold leading-6 text-gray-900">Medications</h3>
               </div>
               <div className=" flex-shrink-0">
                  <button
                     type="button"
                     onClick={refetch}
                     className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                     Reload
                  </button>
               </div>
            </div>
         )}
         <div className="flex-auto bg-white justify-start p-3 text-start">
            <AppListing listData={listData} cols={cols} loading={isListingLoading} />
            {showDetailsInfoPopup.state && (
            <MainPageDialog
              title={"Pharmacy Detail"}
              modalSize="small"
              onCancelHandler={()=>setShowDetailsInfoPopup({state:false,dataObj:null})}
              footer={false}
              maxHeight={true}
            >
              <MedicationDetailPharmacyDialog
                dataObj={showDetailsInfoPopup.dataObj}
                setShowDetailsInfoPopup={setShowDetailsInfoPopup}

              />
            </MainPageDialog>
          )}
         </div>
      </>
   );
};
